import React, { useEffect, useState } from 'react';
import { Save, CheckCircle, XCircle } from 'lucide-react';

const MasterDokumen = () => {
  const [docs, setDocs] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetchDocs();
  }, []);

  const fetchDocs = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${BASE_URL}/api/document-types`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    setDocs(data);
  };

  const toggleMandatory = async (id, currentStatus) => {
    const token = localStorage.getItem('token');
    await fetch(`http://localhost:5000/api/document-types/${id}`, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}` 
      },
      body: JSON.stringify({ is_mandatory: !currentStatus })
    });
    fetchDocs(); // Refresh data
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-sm border border-slate-200">
      <h2 className="text-xl font-bold mb-4">Pengaturan Master Dokumen</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-100 text-slate-600 text-sm">
              <th className="p-3">Nama Dokumen</th>
              <th className="p-3 text-center">Wajib (Mandatory)</th>
              <th className="p-3 text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {docs.map((doc) => (
              <tr key={doc.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="p-3 font-medium">{doc.name}</td>
                <td className="p-3 text-center">
                  {doc.is_mandatory ? (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-bold">
                      Wajib
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 text-green-700 rounded text-xs">
                      Opsional
                    </span>
                  )}
                </td>
                <td className="p-3 text-center">
                  <button 
                    onClick={() => toggleMandatory(doc.id, doc.is_mandatory)}
                    className="text-blue-600 hover:underline text-sm"
                  >
                    Ubah Status
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MasterDokumen;